import { faArrowRight, faBahai, faBolt, faBullhorn, faBullseye, faBullseyePointer, faBusinessTime, faCalendar, faCalendarAlt, faCalendarCheck, faCalendarStar, faChartArea, faChartColumn, faChartPieAlt, faCheckCircle, faCirclePhone, faCode, faColumns, faContactBook, faCubes, faEnvelope, faEnvelopeCircle, faEye, faFileAlt, faFileImport, faFolder, faHeadSideBrain, faHomeAlt, faList, faMapPin, faMessageTimes, faNoteMedical, faNotes, faPen, faPencil, faPhone, faPlusCircle, faPoundSign, faQuestionCircle, faSignal3, faSignature, faTasks, faTasksAlt, faThumbTack, faUser, faUserCircle, faWaveformCircle, } from "@fortawesome/pro-regular-svg-icons";
export var iconsMapping = {
    "Create.png": faPen,
    "List.png": faList,
    "Import.png": faFileImport,
    "Schedule_Call.png": faCirclePhone,
    "Today.png": faCalendarStar,
    "View_Create_Email_Templates.png": faCode,
    "View_Email_Templates.png": faEye,
    "Setup_Email.png": faEnvelopeCircle,
    "View_Diagnostics.png": faNoteMedical,
    "Create_Person_Form.png": faUserCircle,
    "Resource_Chart.png": faChartArea,
    "View_Project_Tasks.png": faCheckCircle,
    "List_Maps.png": faList,
    "Quick_Radius_Map.png": faBolt,
    "Createjjwg_Address_Cache.png": faPen,
    "jjwg_Address_Cache.png": faList,
    "View_Process_Audit.png": faWaveformCircle,
    "Add.png": faPlusCircle,
};
var colors = [];
/*function Colorstest() {
  return useGenerateDistinctColors(
    "15",
    "400",
    colorBase,
    "goldenRatio",
    endColor,
    midColor
  );
}
console.log("colors", Colorstest());*/
export var IconMappingModule = {
    Home: faHomeAlt,
    Accounts: faUser,
    Contacts: faContactBook,
    Opportunities: faBusinessTime,
    AOS_Quotes: faPoundSign,
    Leads: faBahai,
    Documents: faFileAlt,
    Emails: faEnvelope,
    AOS_Invoices: faPoundSign,
    AOS_Contracts: faSignature,
    Cases: faFolder,
    Prospects: faBullseyePointer,
    ProspectLists: faBullseye,
    AM_ProjectTemplates: faColumns,
    FP_events: faCalendarCheck,
    FP_Event_Locations: faCalendarAlt,
    AOS_Products: faSignal3,
    AOS_Product_Categories: faCubes,
    AOS_PDF_Templates: faPencil,
    jjwg_Maps: faThumbTack,
    jjwg_Markers: faMapPin,
    //jjwg_Areas
    jjwg_Address_Cache: faThumbTack,
    AOR_Reports: faChartColumn,
    AOW_WorkFlow: faArrowRight,
    AOK_KnowledgeBase: faHeadSideBrain,
    AOK_Knowledge_Base_Categories: faHeadSideBrain,
    Surveys: faQuestionCircle,
    EmailTemplates: faEnvelope,
    Project: faChartPieAlt,
    Users: faUser,
    Calendar: faCalendar,
    Notes: faNotes,
    Tasks: faTasks,
    Campaigns: faBullhorn,
    Meetings: faMessageTimes,
    Calls: faPhone,
    ProjectTask: faTasksAlt,
};
